export default __webpack_public_path__ + "static/media/Ab4.37a9961a.mp3";